import React, { useState } from 'react';
import { Loader2 } from "lucide-react";

const ReviewNotesModal = ({ show, onClose, onSubmit, decisionType, loading, bulkCount = 0 }) => {
    const [note, setNote] = useState("");

    if (!show) return null;

    const isApprove = decisionType === "approve";
    const actionLabel = isApprove ? "Approve" : "Deny";
    const title = bulkCount > 1
        ? `${actionLabel} ${bulkCount} Requests`
        : `${actionLabel} Request`;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-1">{title}</h3>
                <p className="text-sm text-gray-500 mb-4">Add an optional note for this review.</p>

                <textarea
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 outline-none transition resize-y min-h-[80px] text-sm mb-4"
                    placeholder="Review notes (optional)"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    disabled={loading}
                    autoFocus
                />

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="!px-4 !py-2 !text-sm !font-medium !text-gray-600 !bg-transparent !border !border-gray-200 !rounded-xl hover:!bg-gray-50 !transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onSubmit(note)}
                        disabled={loading}
                        className={`!px-4 !py-2 !text-sm !font-semibold !text-white !border-none !rounded-xl !shadow-sm hover:!shadow-md !transition-all !inline-flex !items-center !gap-2 ${
                            isApprove
                                ? '!bg-emerald-600 hover:!bg-emerald-700'
                                : '!bg-rose-600 hover:!bg-rose-700'
                        }`}
                    >
                        {loading ? (
                            <><Loader2 size={14} className="animate-spin" /> Submitting...</>
                        ) : (
                            actionLabel
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReviewNotesModal;
